import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from "../BaseService";
import { UrlService } from "../UrlService";

@Injectable()
export class ChatMessageService {
	private url: string;

	constructor(
		private myBaseService: BaseService,
		private urlService: UrlService
	) {
		this.url = urlService.getURL('ChatMessage');
	}
	getUnreadDispatchCount(): Observable<number> {
		return this.myBaseService.post(null, this.url + '/DispatchUnreadCount', true);
	}

	loadAll(searchObj: TooBig4Car.Logic.SearchVM): Observable<TooBig4Car.Logic.ChatPersonGroupVM[]> {
		return this.myBaseService.post(searchObj, this.url +'/Search', true);
	}
	markRead(id: System.Guid): Observable<TooBig4Car.Logic.ChatMessage> {
		return this.myBaseService.post(null, this.url + '/MarkRead/' + (id || ""), true);
	}
	save(tempItem: TooBig4Car.Logic.ChatMessage): Observable<TooBig4Car.Logic.ChatMessage> {
		return this.myBaseService.save(tempItem, this.url);
	}
	deleteItem(id: System.Guid): Observable<boolean> {
		return this.myBaseService.deleteItem(id, this.url);
	}
}

